module.exports = __webpack_public_path__ + "static/media/Houses_Of_Parliament_882x496_Colour.a97138c1.png";